import React from "react";

const Blocks = () => {
  return <h1>Blocks Page</h1>;
};

export default Blocks;